import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import Actions from '../actions';

import Pay from '../components/Pay';
import Loader from '../components/Loader';
import OrderData from '../components/OrderData';
import PaidSuccess from '../components/PaidSuccess';

const Home = (props) => {
  const { paymentOrder, getPaymentOrder } = props;
  const urlParams = new URLSearchParams(props.location.search);
  const orderId = urlParams.get('order_id');
  const success = urlParams.get('success');
  const timeOut = success ? 2000 : 0;

  React.useEffect(() => {
    if (!paymentOrder) setTimeout(() => { getPaymentOrder(orderId); }, timeOut);
  }, [paymentOrder, getPaymentOrder]);

  return (
    <>
      {
        !paymentOrder ? <Loader /> : null
      }
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f6f9fc', height: '100vh',
      }}
      >
        {
          paymentOrder && paymentOrder.error
            ? <h3>{paymentOrder.error}</h3>
            : (
              <div>
                <div>
                  {
                    paymentOrder && paymentOrder.isPaid ? <PaidSuccess /> : null
                  }
                </div>
                <div style={{ marginTop: 15 }}>
                  {
                    paymentOrder ? <OrderData paymentOrder={paymentOrder} /> : null
                  }
                </div>
                <div>
                  {
                    paymentOrder && !paymentOrder.isPaid ? <Pay paymentOrder={paymentOrder} /> : null
                  }
                </div>
              </div>
            )
        }
      </div>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    paymentOrder: state.payment.data,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
